import styled from 'styled-components'

const ModalSetRewardTemplateStyled = styled.div`
  width: 1140px;
  position: relative;
  background-color: #4df285;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;

  .set-reward-template-modal {
    background-color: ${({ theme }) => theme.color.neutral};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
    padding: 8px 30px 15px;
    position: relative;
    min-height: 300px;
    min-width: 950px;
    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: ${({ theme }) => theme.color.transparent};
      border: none;
      z-index: 1;
    }

    .line {
      border-bottom: 2px solid ${({ theme }) => theme.color.black};
    }

    .height-85 {
      height: 90px;
    }

    .height-45 {
      height: 45px;
      margin-top: 10px;
    }

    .flex-box-actions {
      display: flex;
    }

    .title-reward-template-container {
      padding-bottom: 10px;
      font-size: 30px;
      font-weight: 600;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
    }

    .reward-template-container {
      .ant-form {
        width: 100%;
      }

      .apply-action {
        padding: 0px 40px;
        margin-top: 24px;
        display: flex;
        align-items: end;
        justify-content: space-between;
        gap: 120px;
      }

      .actions {
        margin-top: 30px;
        padding: 0px 40px;
        .clear-save-action {
          margin-top: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 80px;
        }
      }

      .line__guild--gradiant {
        height: 2px;
        padding: 8px 0;
        margin-top: 30px;
        img {
          width: 100%;
          height: 2px;
        }
      }

      .items-reward-container {
        height: 412px;
        overflow: auto;
        color: #DEDEDE;
        scrollbar-gutter: stable;
        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        ::-webkit-scrollbar-track {
          border-radius: 10px;
          background: rgba(110, 109, 109, 0.1);
        }
        ::-webkit-scrollbar-thumb{
          border-radius: 10px;
          background: rgba(110, 109, 109, 0.34);
        }
        ::-webkit-scrollbar-thumb:hover{
          background: rgba(110, 109, 109, 0.34);
        }
        ::-webkit-scrollbar-thumb:active{
          background: rgba(110, 109, 109, 0.34);
        }
        .rendered-items {
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding: 0px 16px;
        }
        .border-error {
          border: 1px solid #731c2b;
        }
        .item-inner {
          padding: 12px 40px;
          display: grid;
          grid-template-columns: 0.75fr 1.25fr 0.75fr 0.75fr 0.25fr;
          column-gap: 24px;
          row-gap: 40px;
        }
        .border-styled {
          border-bottom: 2px solid #484B52;
          padding-bottom: 8px;
        }
        .mt-32 {
          margin-top: 16px;
        }
        .view-item {
          text-align: center;
          .column-title {
            font-size: 24px;
          }
        }
        .icon-delete {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .input-disabled {
          filter: brightness(0.5);
        }
      }

      .color-DEDEDE {
        color: #DEDEDE;
      }

      .title-label {
        display: flex;
        align-items: center;
        font-size: 18px;
      }

      .request__red {
        color: red;
        padding-left: 5px;
      }

      .box-select {
        width: 100%;
        position: relative;
      }

      .title-select-box {
        color: #ffffff;
        font-size: 20px;
        text-align: center;
      }

      .select-name {
        color: #ffffff;
      }

      .box-btn {
        width: 100%;

        .btn-prize-pool {
        }
      }

      .disable-box {
        .align-items-center {
          background-color: #1e2236;
        }
      }

      .start-in-contain {
        display: flex;
        justify-content: space-between;
        position: relative;

        .child-start-in {
          width: 30%;
          position: relative;

          .pre-name {
            position: absolute;
            top: 8px;
            right: 15px;
            color: rgb(157, 157, 157);
            font-size: 18px;
          }
        }

        .text_error {
          position: absolute;
          top: 44px;
          color: #ff4d4f;
          font-size: 16px;
          width: 100%;
        }
      }

      .btn-create {
        display: flex;
        justify-content: center;
        width: 100%;

        .ant-form-item {
          margin: 0;
        }
      }

      .ant-form-item-explain-error {
        font-size: 16px;
      }
    }
    .disabled-opacity {
      opacity: 0.3;
    }
    .search-input {
      padding: 4px 0 4px 11px;
    }
    .text_error_race {
      position: absolute;
      top: 69px;
      color: #ff4d4f;
      font-size: 16px;
      width: 100%;
    }
  }
`

export default ModalSetRewardTemplateStyled
